import React, { useState, useMemo, createContext, useContext } from 'react';
import PropTypes from 'prop-types';

const ForgotPasswordContext = createContext();

function ForgotPasswordProvider({ children }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [userCode, setUserCode] = useState('');
  const [error, setError] = useState();
  const [isPasswordChanged, setIsPasswordChanged] = useState(false);

  return (
    <ForgotPasswordContext.Provider
      value={useMemo(
        () => ({
          email,
          setEmail,
          password,
          setPassword,
          userCode,
          setUserCode,
          error,
          setError,
          isPasswordChanged,
          setIsPasswordChanged,
        }),
        [email, setEmail, password, setPassword, userCode, setUserCode, error, setError, isPasswordChanged, setIsPasswordChanged],
      )}
    >
      {children}
    </ForgotPasswordContext.Provider>
  );
}

function useForgotPasswordContext() {
  const context = useContext(ForgotPasswordContext);
  if (!context) {
    throw new Error('Context is not initialised');
  }
  return context;
}

ForgotPasswordProvider.propTypes = {
  children: PropTypes.element,
};

export { ForgotPasswordProvider, useForgotPasswordContext };
